gsap.registerPlugin(ScrollTrigger, Draggable);

document.addEventListener("DOMContentLoaded", function () {

    //sec 1

    const swiperHero = new Swiper('.co-home-s1--slider', {
        // Default parameters
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 600,
        autoplay: {
            delay: 10000,
        },
        navigation: {
            nextEl: '.co-home-s1--next',
            prevEl: '.co-home-s1--prev',
        },
    });

    gsap.set('.co-home-s1-bg img', { scale: 1 });
    gsap.to('.co-home-s1-bg img', {
        scrollTrigger: {
            trigger: '.co-home-s1',
            start: "top bottom",
            end: "150% top",
            scrub: true,
        },
        scale: 1.5
    });

    //sec 1 end

    //sec 3
    gsap.set('.co-home-s3--decor', { xPercent: -110, yPercent: 0, rotate: '10deg' });
    gsap.to('.co-home-s3--decor', {
        scrollTrigger: {
            trigger: '.co-home-s3',
            // toggleActions: "restart none none",
            // markers: true,
            start: '-30% 100%',
            end: "150% bottom",
            scrub: true,
            // markers: true,
            invalidateOnRefresh: true,
        },
        xPercent: 150,
        yPercent: 30,
        // rotate: '12deg'
    });
    //sec 3 end

    //sec 4
    document.querySelectorAll('.co-home-s4-media--line').forEach(rotator => {
        const inner = rotator.querySelector('.co-home-s4-media--line_inner');
        const count = inner.children.length;

        // clone first for seamless loop
        inner.appendChild(inner.children[0].cloneNode(true));

        const visibleTime = 1.2;  // seconds visible
        const slideTime = 0.8;  // seconds sliding
        const stepTime = visibleTime + slideTime;
        const totalDuration = count * stepTime;

        rotator.style.setProperty('--duration', totalDuration + 's');

        let keyframes = `@keyframes rotate {`;

        for (let i = 0; i < count; i++) {
            const start = (i * stepTime) / totalDuration * 100;
            const hold = ((i * stepTime) + visibleTime) / totalDuration * 100;
            const move = -i * 100;

            keyframes += `
      ${start}% { transform: translateY(${move}%); }
      ${hold}% { transform: translateY(${move}%); }
    `;
        }

        keyframes += `
    100% { transform: translateY(${-count * 100}%); }
  }`;

        const style = document.createElement('style');
        style.innerHTML = keyframes;
        document.head.appendChild(style);
    });

    gsap.set('.co-home-s4-media--image img', { yPercent: 10, height: '115%', scale: 1 });
    gsap.to('.co-home-s4-media--image img', {
        scrollTrigger: {
            trigger: '.co-home-s4',
            start: "top bottom",
            end: "bottom top",
            scrub: true,
        },
        yPercent: -5,
        scale: 1.05
    });
    //sec 4 end


    //sec 5
    let panels = gsap.utils.toArray(".co-home-s5-frame");
    panels.forEach((panel, i) => {
        i = i + 1;
        panel.classList.add("panel-" + i);

        let panelIMG = panel.querySelector('.image-wrp img');

        gsap.set(panelIMG, { yPercent: -10, height: '120%', scale: 1.1 });
        gsap.to(panelIMG, {
            scrollTrigger: {
                trigger: panel,
                start: "top bottom",
                end: "150% bottom",
                scrub: true,
            },
            yPercent: 0,
            scale: 1
        });
    });
    const panelsWrapp = document.querySelector('.co-home-s5');


    // if (window.matchMedia("(min-width: 1024px)").matches) {


    let pli = panels.length - 1;

    const newPanels = panels.slice(0, -1);
    // console.log(panelsWrapp.offsetHeight);
    newPanels.forEach((panel) => {
        ScrollTrigger.create({
            trigger: panel,
            start: () => panel.offsetHeight < window.innerHeight ? "top 100px" : "bottom bottom",
            endTrigger: panels[pli],
            end: "90% bottom",
            pin: true,
            pinSpacing: false,
            // markers: true
        });
    });
    // }


    //end sec 5

    //sec 8

    const swiperBlog = new Swiper('.co-home-s8-slider', {
        // Default parameters
        slidesPerView: 4,
        spaceBetween: 32,
        loop: true,
        speed: 600,
        loopAddBlankSlides: true,
        loopAdditionalSlides: 5,
        observer: true, // Listens for changes in the DOM of the Swiper container
        observeParents: true,
        initialSlide: 5,
        autoplay: {
            delay: 10000,
        },
        navigation: {
            nextEl: '.co-home-s8--next',
            prevEl: '.co-home-s8--prev',
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
                spaceBetween: 25
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 2,
                spaceBetween: 22
            },
            // when window width is >= 640px
            768: {
                slidesPerView: 3,
                spaceBetween: 26
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 32
            }
        }
    })
    window.addEventListener('load', () => {
        swiperBlog.update();
    });

    //sec 8 end

    //sec 9

    const tls9 = gsap.timeline({
        scrollTrigger: {
            trigger: ".co-home-s9",
            start: "-10% 100%",
            end: "100% bottom",
            // markers: true,
            toggleActions: "play reset play reset"
        }
    });
    tls9.fromTo(".co-home-s9--decor.decor-4",
        { xPercent: 0, yPercent: 0, opacity: 0 },
        { xPercent: 0, yPercent: 0, opacity: 1, duration: 1, ease: "power2.out" },
        "0"
    );
    tls9.fromTo(".co-home-s9--decor.decor-3",
        { xPercent: -210, yPercent: 0, opacity: 0 },
        { xPercent: 50, yPercent: 0, opacity: 1, duration: 1, ease: "power2.out" },
        "0.2"
    );
    tls9.fromTo(".co-home-s9--decor.decor-2",
        { xPercent: -150, yPercent: 0, opacity: 0 },
        { xPercent: 50, yPercent: 0, opacity: 1, duration: 1, ease: "power2.out" },
        "0.4"
    );
    tls9.fromTo(".co-home-s9--decor.decor-1",
        { xPercent: -110, yPercent: 20, opacity: 0 },
        { xPercent: 50, yPercent: 0, opacity: 1, duration: 1, ease: "power2.out" },
        "0.6"
    );







    // gsap.to('.co-home-s9--decor.decor-1', {
    //     scrollTrigger: {
    //         trigger: '.co-home-s9',
    //         markers: true,
    //         start: '-30% 100%',
    //         // end: "150% bottom",
    //         // scrub: true,
    //         // markers: true,
    //         invalidateOnRefresh: true,
    //         toggleActions: "play none none none"
    //     },
    //     xPercent: 50,
    //     yPercent: 0,
    //     duration: 1,

    // });
    // decor 2
    // gsap.to('.co-home-s9--decor.decor-2', {
    //     scrollTrigger: {
    //         trigger: '.co-home-s9',
    //         markers: true,
    //         start: '-10% 100%',
    //         // end: "150% bottom",
    //         // scrub: true,
    //         // markers: true,
    //         invalidateOnRefresh: true,
    //         toggleActions: "play none none none"
    //     },
    //     xPercent: 50,
    //     yPercent: 0,
    //     duration: 1,
    //     // delay: 1,
    //     stagger: 10.25,
    // });

    // gsap.utils.toArray(".co-home-s9--decor").forEach(element => {
    //     gsap.to(element, {
    //         scrollTrigger: {
    //             trigger: '.co-home-s9',
    //             markers: true,
    //             start: '-10% 100%',
    //             // end: "150% bottom",
    //             // scrub: true,
    //             // markers: true,
    //             invalidateOnRefresh: true,
    //             toggleActions: "play none none none"
    //         },
    //         xPercent: 50,
    //         yPercent: 0,
    //         duration: 1,
    //         // delay: 1,
    //         stagger: 0.25,
    //         interval: 1,
    //     })
    // });

    // ScrollTrigger.create({
    //     trigger: ".co-home-s9",
    //     markers: true,
    //     start: '-10% 100%',
    //     onEnter: () => {
    //         gsap.to(".co-home-s9--decor", {
    //             xPercent: 50,
    //             yPercent: 0,
    //             opacity: 1,
    //             stagger: 0.35,
    //             duration: 1,
    //             ease: "power2.out"
    //         });
    //     }
    // });

    var container = document.querySelector('.co-home-s9-frame');
    // var vw = container.offsetWidth + 100;
    // var vh = container.offsetHeight + container.offsetHeight * 0.8;
    // var th = container.offsetHeight * 0.8 / 2 * (-1);

    Draggable.create(".co-home-s9-image", {
        // bounds: ".co-about-s1--media",
        inertia: true,
        bounds: container,
        // bounds: {
        //     rigth: -200,
        // }
    });

    //sec 9 end


    //sec 10
    //Simple Accordion
    var coAccItemsS10 = document.querySelectorAll(".co-home-s10-accordion--title");
    coAccItemsS10.forEach(function (groupItem, index) {
        var nextElement = groupItem.nextElementSibling;
        if (index === 0 || groupItem.classList.contains("active")) {
            groupItem.classList.add("active");
            nextElement.classList.add("active");

            gsap.to(nextElement, {
                height: "auto",
                duration: 0.3,
                ease: "power2.inOut",
            });
        } else {
            nextElement.classList.remove("active");
            gsap.to(nextElement, {
                height: 0,
                duration: 0.3,
                ease: "power2.inOut",
            });
        }

        groupItem.addEventListener("click", function (e) {
            e.preventDefault();
            // Check if the parent element already has the 'active' class
            if (!this.classList.contains("active")) {
                // If not active, hide all other sections
                coAccItemsS10.forEach(function (otherAccItem, otherIndex) {
                    otherAccItem.classList.remove("active");
                    otherAccItem.nextElementSibling.classList.remove("active");

                    gsap.to(otherAccItem.nextElementSibling, {
                        height: 0,
                        duration: 0.3,
                        ease: "power2.inOut",
                    });
                });
                // Add 'active' class to the clicked item and show its content
                this.classList.add("active");
                nextElement.classList.add("active");
                gsap.to(nextElement, {
                    height: "auto",
                    duration: 0.3,
                    ease: "power2.inOut",
                });
            } else {
                // remove 'active' if clicked on 'active'
                this.classList.remove("active");
                nextElement.classList.remove("active");
                gsap.to(nextElement, {
                    height: 0,
                    duration: 0.3,
                    ease: "power2.inOut",
                });
            }

            ScrollTrigger.refresh(true)
            // If already active, don't hide the content
        });


    });

    // coAccItemsS10.forEach(function (item, index) {
    //     if (index >= 4) {
    //         item.closest('.co-home-s10-accordion-item').classList.add('hidden');
    //     }
    // });
    //sec 10 end

    // Product section 2
    const sec6CustomBullets = document.querySelectorAll('.co-product-s2-titles span');
    const sec6CustomBulletsArr = Array.from(sec6CustomBullets);
    const sec6BulletsArr = sec6CustomBulletsArr.map((item) => item.textContent.trim());
    const sec6Swiper = new Swiper('.co-product-s2-swiper', {
        effect: 'fade',
        loop: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        allowTouchMove: false,
        fadeEffect: {
            crossFade: true,
        },
        speed: 500,
        pagination: {
            el: '.co-product-s2 .swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + sec6BulletsArr[index] + '</span>';
            },
        },
        navigation: {
            nextEl: '.co-product-s2 .swiper-button-next',
            prevEl: '.co-product-s2 .swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
        },
    });
    //Product section 2 end


    //footer
    gsap.set('.co-footer--bottom img', { yPercent: 0, scale: 1.3 });
    gsap.to('.co-footer--bottom img', {
        scrollTrigger: {
            trigger: '.co-footer',
            // toggleActions: "restart none none",
            // markers: true,
            start: '25% bottom',
            end: "150% bottom",
            scrub: true,
            // markers: true,
            invalidateOnRefresh: true,
        },
        yPercent: 0,
        scale: 1
        // rotate: '12deg'
    });
    //footer end
});

// Initialization function
// const initCards = () => {
//     scrollCards(); // Apply scroll-triggered animations
// };

function initCards() {
    scrollCards();
}

const contentElements = [...document.querySelectorAll('.co-home-s5-frame')];
const totalContentElements = contentElements.length;

const scrollCards = () => {
    contentElements.forEach((el, position) => {

        const isLast = position === totalContentElements - 1;

        gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: 'center center',
                end: '+=150%',
                scrub: true
            }
        }).to(el, {
            ease: 'none',
            scale: 1,
            opacity: 1,
            yPercent: 0
        }, 0);

    });
};